(function () {
  const MODAL_FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  let lastModalTrigger = null;
  let openModal = null;

  function setModalState(modal, isOpen) {
    if (!modal) return;

    if (isOpen) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("pl-modal-open");
      openModal = modal;
      const focusTarget = modal.querySelector(".pl-modal__close") || modal.querySelector(MODAL_FOCUSABLE_SELECTOR);
      if (focusTarget instanceof HTMLElement) focusTarget.focus();
      return;
    }

    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("pl-modal-open");
    openModal = null;
    if (lastModalTrigger instanceof HTMLElement) {
      lastModalTrigger.focus();
      lastModalTrigger = null;
    }
  }

  function initFeaturedCollection(section) {
    if (!section || section.dataset.sliderEnabled !== "true" || typeof Swiper === "undefined") {
      return;
    }

    const slider = section.querySelector(".blj-featured-collection__swiper");

    if (!slider || slider.dataset.initialized === "true") {
      return;
    }

    slider.dataset.initialized = "true";

    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      pagination: {
        el: section.querySelector(".blj-featured-collection__pagination"),
        clickable: true
      },
      navigation: {
        nextEl: section.querySelector(".blj-featured-collection__arrow--next"),
        prevEl: section.querySelector(".blj-featured-collection__arrow--prev")
      },
      breakpoints: {
        750: {
          slidesPerView: Number(section.dataset.mobileColumns || 2),
          spaceBetween: 20
        },
        990: {
          slidesPerView: Number(section.dataset.desktopColumns || 4),
          spaceBetween: 24
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-featured-collection-section]").forEach(initFeaturedCollection);
  }

  function initModalDescriptionScrollbar(scope = document) {
    if (typeof window.SimpleBar === "undefined") return;
    const targets = scope.querySelectorAll("[data-pl-modal-description-scroll]");
    targets.forEach((target) => {
      if (target.hasAttribute("data-simplebar")) return;
      target.setAttribute("data-simplebar", "");
      target.setAttribute("data-simplebar-auto-hide", "true");
      target.setAttribute("data-simplebar-force-visible", "false");
      new window.SimpleBar(target, { autoHide: true });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll();
    initModalDescriptionScrollbar(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    initFeaturedCollection(event.target);
    initModalDescriptionScrollbar(event.target);
  });

  document.addEventListener("click", function (event) {
    const cardBtn = event.target.closest(".blj-card-btn");
    if (cardBtn) {
      event.preventDefault();
      lastModalTrigger = cardBtn;
      const card = cardBtn.closest(".blj-product-card");
      if (!card) return;
      const productId = card.getAttribute("data-product-id");
      const modal = document.getElementById(`bljModal-${productId}`);
      setModalState(modal, true);
      return;
    }

    const closeBtn = event.target.closest(".pl-modal__close, .pl-modal__backdrop, [data-close-modal]");
    if (closeBtn) {
      event.preventDefault();
      const modal = closeBtn.closest(".pl-modal");
      setModalState(modal, false);
      return;
    }

    const chooseBtn = event.target.closest(".pl-modal .quick-add__button--choose");
    if (chooseBtn) {
      const modal = chooseBtn.closest(".pl-modal");
      setModalState(modal, false);
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (!openModal || openModal.getAttribute("aria-hidden") !== "false") return;

    if (event.key === "Escape") {
      event.preventDefault();
      setModalState(openModal, false);
      return;
    }

    if (event.key !== "Tab") return;

    const focusable = Array.from(openModal.querySelectorAll(MODAL_FOCUSABLE_SELECTOR)).filter((el) => {
      return el instanceof HTMLElement && !el.hasAttribute("disabled");
    });

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
